import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UtilState } from './utils.state';

const selectUtilState = createFeatureSelector<UtilState>('util');

export const selectUtilUi = createSelector(
    selectUtilState,
    (state: UtilState) => state.ui
);

export const selectUtilData = createSelector(
    selectUtilState,
    (state: UtilState) => state.data
);
